


import { Routes, RouterModule } from '@angular/router';
import { UserGroupComponent } from './usergroup.component';

const routes: Routes = [
    {
        path: '',
        component: UserGroupComponent
    },
];

export const UserGroupRoutes = RouterModule.forChild(routes);
